import { render, staticRenderFns } from "./ResendConfirmCodePage.vue?vue&type=template&id=143100d1&scoped=true"
import script from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
export * from "./ResendConfirmCodePage.vue?vue&type=script&lang=ts"
import style0 from "./ResendConfirmCodePage.vue?vue&type=style&index=0&id=143100d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143100d1",
  null
  
)

export default component.exports